import { Content } from "../content"

export default ({showInMobileOnly, showInDesktopOnly, children, mt = 0}) => {
    const _css = showInMobileOnly ? {
        '@smMax': {display: "flex"},
        '@smMin': {display: "none"}
    } : (showInDesktopOnly ? {
        '@smMax': {display: "none"},
        '@smMin': {display: "flex"}
    } : {
        display: "flex"
    })

    return (
        <>
            <Content contentCss={
                Object.assign(_css, {justifyContent: "center", marginTop: mt})
            }>
                {children}
            </Content>
        </>
    )
}